<template>
  <v-row no-gutters>
    <v-col>
      <template
        v-for="(r, ri) in headerRows">
        <v-row v-if="r.showGroupHeader"
        :key="'rgh' + ri"
        no-gutters
        class="flex-nowrap">
          <v-col class="first-column group-header sub-row" style="min-width: 100%;"
          ><div
            :style="{ marginLeft: 8 + (r.item.indentLevel * 25) + 'px' }">
            {{r.showGroupHeader}}
          </div></v-col>
        </v-row>
      <v-row
        :key="'r' + ri"
        no-gutters
        class="flex-nowrap"
      >
        <v-col
          v-if="r.isDetail && !r.isGroupHeader"
          :style="{ height: r.height, minWidth: r.width.remainder }"
        >
          <v-row class="flex-nowrap" no-gutters v-if="!r.isGroupHeader">
            <v-col
              :class="r.cssClassMeasure + m.cssClass + (mi === visibleMeasures.length - 1 ? r.cssClassMeasureLast : '') + ' col-resizable'"
              :style="{ height: r.height, minWidth: m.widthPct, maxWidth: m.widthPct }"
              v-for="(m, mi) in visibleMeasures"
              :key="'r' + ri + 'm' + mi"
            >
              <div class="col-resize-handle" title="Drag to resize; double-click to reset"
                @click.stop
                @dblclick.stop="$emit('resetColumnWidth', 'VM:' + (m.id || m.column))"
                @pointerdown.stop.prevent="$emit('resizeColumn', $event, 'VM:' + (m.id || m.column), m.widthPx)"></div>
              <MeasureDisplay class="row-header-measure"
                :item="r.item"
                :measure="m"
                :selectable="m.type === 'job_count'"
                @click="$emit('selectJob', r.item)"
                @showDocList="$emit('showDocList', $event)"
                @showLinkedDocs="$emit('showLinkedDocs', ...arguments)"
                @drilldown="$emit('drilldown', ...arguments)"
              ></MeasureDisplay>
            </v-col>
            <!-- <v-col cols="1" style="background-color: lightgreen"
              > {{visibleMeasures.length}}
            </v-col> -->
          </v-row>
        </v-col>
        <v-col
          v-else-if="r.subRows.length"
          :style="{ minWidth: r.width.remainder }"
        >
          <RowMeasures
            :headerRows="r.subRows"
            :visibleMeasures="visibleMeasures"
            :catalogueDocType="catalogueDocType"
            :rowSelectable="false"
            :searchTerms="searchTerms"
            @openDocumentID="$emit('openDocumentID', $event)"
            @openDocActionsMenuContext="
              (event, item) => $emit('openDocActionsMenuContext', event, item)
            "
            @openDocument="$emit('openDocument', $event)"
            @copyDocument="$emit('copyDocument', $event)"
            @showMatches="(event, item) => $emit('showMatches', item)"
            @selectJob="$emit('selectJob', $event)"
            @doMenuAction="
              (event, item, axis) => $emit('doMenuAction', event, item, axis)
            "
            @viewNodeDoc="(event, item) => $emit('viewNodeDoc', event, item)"
            @drilldown="$emit('drilldown', ...arguments)"
            @resizeColumn="$emit('resizeColumn', ...arguments)"
            @resetColumnWidth="$emit('resetColumnWidth', ...arguments)"
          ></RowMeasures>
        </v-col>
      </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import MeasureDisplay from "@/components/jobArchitecture/MeasureDisplay.vue";

export default {
  name: "RowMeasures",
  components: {
    MeasureDisplay,
  },
  props: {
    headerRows: { type: [], required: true },
    visibleMeasures: { type: [], required: true },
    catalogueDocType: { type: Object, required: false },
    rowSelectable: { type: Boolean, required: false, default: false },
    searchTerms: { type: [], required: false },
  },
  data: function () {
    return {
      response: null,
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/vars";

</style>
